<template>
    <modal name="cookie" height="auto" classes="on-top" scrollable adaptive>
        <app-card :title="$t('Data processing conditions')">
            <div v-if="terms" class="container text-left" v-html="terms[locale]"></div>
            <div class="text-right">
                <app-button native-type="button" @click="acceptCookies">
                    {{ $t('Accept') }}
                </app-button>
                <app-button type="outline-warning" native-type="button" @click="hide">
                    {{ $t('Cancel') }}
                </app-button>
            </div>
        </app-card>
    </modal>
</template>

<script>
import PublicPageService from '@services/publicPage.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            loading: false,
            terms: null
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        acceptCookies() {
            this.$emit('acceptCookies');
            this.hide();
        },
        hide() {
            this.$modal.hide('cookie');
        },
        getTerms() {
            PublicPageService.publicShow('cookie').then(res => {
                this.terms = res;
            });
        }
    },
    created() {
        this.getTerms();
    }
};
</script>
<style scoped>
.on-top {
    z-index: 1022;
}
</style>
